import $state from '../download-state.js'
import Api from '~/store/idonia-api/api.js'
import store from '~/store/store'
import useLanguageTree from '~/commons/language'
const {t} = useLanguageTree()

export default function (payload) {
  return new Promise((resolve, reject) => {
    if (payload.endpoint) {
      let params = {}
      if (this.$route.params.sha) {
        params = {
          token: this.$store.state.session.guestSessions[this.$route.params.sha],
          account_id: 0,
          socket_id: this.$store.state.notifications.guestSockets[this.$route.params.sha].wsID
        }
      }
      payload.request = () => {
        return new Promise((resolve) => {
          Api.download(payload.endpoint, params)
          resolve()
        })
      }
      payload.uuid = payload.file.fileID
      $state.addFile(payload).then(() => {
        resolve(payload.uuid)
      })
    } else {
      Api.get('file/' + payload.file.fileID + '/zip', {
        os: payload.file.os || '',
        arch: payload.file.arch || '',
        excludeViewer: payload.file.excludeViewer,
        sdl: payload.file.sdl || ''
      }, response => {
        console.log(response)
        payload.uuid = response.body.task_id
        $state.addFile(payload).then(() => {
          resolve(payload.uuid)
        })
      }, (e) => {
        console.log('error:', e)
        if (e.status === 406) {
          store.dispatch('dialog/unshiftDialog', {
            title: t('NoDownloadableTitle'),
            body: require('~/components/common/dialog/types/DialogNoDownloadable.vue').default,
            persistent: true,
            props: {'limits': e.body.limits, description: e.body.description},
            width: 480,
            actions: {
              accept: {
                title: 'Close',
                callback: () => {
                  store.dispatch('dialog/clearQueue') // TODO give all dialogs an id and filter this kind of operations¿?
                }
              }
            }
          })
        }
      }, false, payload.headers)
    }
  })
}

export function zipFiles (files, excludeViewer) {
  return new Promise((resolve, reject) => {
    const date = new Date().toLocaleString().split(',')[0]
    const name = t('file') + '-' + date.replaceAll('/', '')
    Api.postV2('files/zip', {
      data: {
        files: files,
        zip_name: name,
        exclude_viewer: excludeViewer
      }
    })
    .then(response => {
      console.log(response)
      let payload = {
        uuid: response.body.task_id,
        file: {
          name: name + '.zip'
        }
      }
      $state.addFile(payload).then(() => {
        resolve(payload.uuid)
      })
    })
    .catch((e) => {
      console.log('error:', e)
      if (e.status === 406) {
        store.dispatch('dialog/unshiftDialog', {
          title: t('NoDownloadableTitle'),
          body: require('~/components/common/dialog/types/DialogNoDownloadable.vue').default,
          persistent: true,
          props: {'limits': e.body.limits, description: e.body.description},
          width: 480,
          actions: {
            accept: {
              title: 'Close',
              callback: () => {
                store.dispatch('dialog/clearQueue') // TODO give all dialogs an id and filter this kind of operations¿?
              }
            }
          }
        })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/plugins/uploader/methods/download.js